import React, { useEffect } from "react";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
export default ({weekPreferences, setweekPreferences, editData}) => {
    let weekDays = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    useEffect(() => {
        // Initialize the schedule state with editData
        if (editData?.length > 0) {
            setweekPreferences(editData);
        }
    }, [editData]);
    const handleChangePicker = async (index, selectedTime, type, day) => {
        setweekPreferences(prevSchedule => {
          const updatedSchedule = [...prevSchedule];
          const existingDayIndex = updatedSchedule.findIndex(item => item.day === day);
          if (existingDayIndex !== -1) {
            updatedSchedule[existingDayIndex] = {
              ...updatedSchedule[existingDayIndex],
              [type]: selectedTime ? selectedTime.format('HH:mm') : '00:00'
            };
          } else {
            updatedSchedule.push({
              day,
              [type]: selectedTime ? selectedTime.format('HH:mm') : '00:00'
           });
          }
          return updatedSchedule;
        });
    };
      

  const formatTime = (timeString) => {
    const date = new Date(`01/01/2000 ${timeString}`);
    return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true });
  };

    return(
        <>  <hr/>
            <h4>Select day and time range</h4>
            <div className="table-responsive">
                <table className="table">
                <thead>
                    <tr>
                    <th> Select Day </th>
                    <th> Earliest Start Time  </th>
                    <th> Latest Start Time  </th>
                    </tr>
                </thead>
                <tbody>
                    {weekDays.length > 0 && weekDays.map((day, i) => {
                        return(
                            <>
                            <tr key={i}>
                                <td> 
                                    <h5>{day}</h5>
                                </td>
                                <td> 
                                    <div className="col-md-5">
                                        <Datetime
                                            value={weekPreferences?.length > 0  && weekPreferences?.find(item => item.day === day)?.start_date ? formatTime(weekPreferences?.length>0 && weekPreferences?.find(item => item.day === day).start_date) : ''}
                                            inputProps={{
                                                placeholder: "00:00",
                                                readOnly: true,
                                                className:"form-control class-time-date-time",
                                                name:'start_date'
                                            }}
                                            dateFormat={false}
                                            timeFormat={true}
                                            inputFormat="HH:mm"
                                            closeOnSelect={true}   
                                            onChange={(selectedDate) => handleChangePicker(i, selectedDate, 'start_date', day)}
                
                                        />
                                    </div>
                                </td>
                                <td>
                                    <div className="col-md-5">
                                        <Datetime
                                            value={weekPreferences?.length > 0  && weekPreferences?.find(item => item.day === day)?.last_date ? formatTime(weekPreferences?.length > 0  && weekPreferences?.find(item => item.day === day).last_date) : ''}

                                            inputProps={{
                                                placeholder: "00:00",
                                                readOnly: true,
                                                className:"form-control class-time-date-time",
                                                name:'last_date'
                                            }}
                                            dateFormat={false}
                                            inputFormat="HH:mm"
                                            timeFormat={true}
                                            closeOnSelect={true}   
                                            onChange={(selectedDate) => handleChangePicker(i, selectedDate, 'last_date', day)}               
                                        />
                                    </div>
                                </td>
                            </tr>
                            </>
                        )
                    })}
                </tbody>
                </table>
            </div>
        </>

    );
};